/**
 * Silences every media element inside a cloned element node. `cloneNode` copies react-player's
 * `autoplay` attribute but not the `muted` property it sets separately, so an untouched clone
 * plays its own unmuted copy of the file.
 */
export default (clone: Element): void => {
    clone.querySelectorAll<HTMLMediaElement>('audio, video').forEach((media) => {
        media.removeAttribute('autoplay');
        media.muted = true;
    });
};
